<script setup>
defineOptions({
  name: 'SidebarNavigationMenu',
})

defineProps({
  menu: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="sidebar-menu py-4 md:py-0 md:pb-4">
    <nav class="flex-col items-stretch justify-start space-y-2 flex text-sm">
      <template
        v-for="item in menu"
        :key="item.label"
      >
        <DTooltip v-if="item.locked || item.disabled">
          <p
            class="pl-2 text-white/50 font-bold text-lg md:text-base"
            :class="{ 'uppercase text-base md:text-xs': item.subMenu }"
            tabindex="-1"
            @click.prevent
          >
            <DIcon
              v-if="item.icon"
              :path="item.icon"
              size="sm"
            />
            {{ item.label }}
            <DIcon
              v-if="item.locked"
              path="cadenas"
              size="sm"
            />
          </p>
          <template #content>
            <p class="w-32">
              {{ item.locked || item.disabled }}
            </p>
          </template>
        </DTooltip>

        <RouterLink
          v-else-if="!item.route && item.subMenu"
          :to="item.subMenu[0].route"
          :aria-selected="item.isActive"
          class="group w-full text-lg md:text-base"
          @click="() => item.subMenu[0].action && item.subMenu[0].action(item.subMenu[0])"
        >
          <span class="inline-block">
            <DIcon
              v-if="item.icon"
              :path="item.icon"
              size="sm"
            />
            {{ item.label }}
          </span>
        </RouterLink>

        <RouterLink
          v-else
          :to="item.route"
          :aria-selected="item.isActive"
          class="group w-full text-lg md:text-base"
          @click="() => item.action && item.action(item)"
        >
          <span class="inline-block text-white">
            <DIcon
              v-if="item.icon"
              :path="item.icon"
              size="sm"
            />
            {{ item.label }}
          </span>
        </RouterLink>
      </template>
    </nav>
  </div>
</template>

<style>
@reference '@/assets/style/index.css';

.sidebar-menu {
  a {
    & > * {
      @apply text-white font-bold pl-2 leading-6 py-2 md:py-0;
    }

    &:hover > * {
      @apply !font-extrabold;
    }

    &[aria-disabled='true'] > * {
      @apply !text-grey-500;
    }

    &[aria-selected='true'] > * {
      @apply bg-white/20 !text-white pr-4 rounded-r-full;
    }
  }

  & > nav > a.active > * {
    @apply bg-white/20 !text-white pr-4 rounded-r-full;
  }
}
</style>
